import {Toast, ToastArea} from 'common/components/toast-area';
// import the whole module to make sure mp-toast-area is registered
import 'common/components/toast-area';

let _toastArea: ToastArea | null = null;

function _getToastArea(): ToastArea {
  if (!_toastArea || !_toastArea.isConnected) {
    _toastArea = document.createElement(`mp-toast-area`) as ToastArea;
    _toastArea.setAttribute(`elref`, `globalToastArea`);
    const rootEl = document.querySelector(`mp-browser-context-root, mp-test-context-root`) ?? document.body;
    rootEl.appendChild(_toastArea);
  }
  return _toastArea;
}

export function clearAllToasts() {
  _getToastArea().clearAllToasts();
}

export function addToast(toast: Toast): Toast {
  return _getToastArea().addToast(toast);
}

export function closeToast(toast: Toast) {
  _getToastArea().closeToast(toast);
}
